import * as actions from "../actions";
import * as requests from "../../../requests/localization/requestCreators";

import { EwaThunk } from "../../types";

const requestLanguage = (): EwaThunk => async (dispatch, getState) => {
  dispatch(actions.GetLanguage());
  try {
    const res = await requests.getLanguage();
    const langCode = res.data;
    dispatch(actions.SuccessGetLanguage(langCode));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (!e.response) console.error(e);
    dispatch(actions.ErrorGetLanguage(e.response));
  }
};

export default requestLanguage;
